
import '@fancyapps/fancybox/dist/jquery.fancybox'

jQuery(document).ready(function($) {
    $('[data-fancybox]').fancybox()
})
